import React from 'react';
import { Button } from 'pvs-design-system';
import { Stack } from '@mui/material';
import Add from '@mui/icons-material/Add';

interface ManageActionsBarProps {
  /** Show the "Add folder" button. */
  canAddFolder: boolean;
  /** Show the "Add resource" button. */
  canAddResource: boolean;
  onAddFolder: () => void;
  onAddResource: () => void;
}

/**
 * The "Add folder" / "Add resource" buttons shown in manage mode above a
 * folder's contents. Renders nothing when neither action is permitted.
 */
const ManageActionsBar: React.FC<ManageActionsBarProps> = ({
  canAddFolder,
  canAddResource,
  onAddFolder,
  onAddResource,
}) => (
  <Stack direction="row" gap={1}>
    {canAddFolder && (
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        sx={{ minWidth: 140 }}
        startIcon={<Add />}
        onClick={onAddFolder}
      >
        Add folder
      </Button>
    )}
    {canAddResource && (
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        sx={{ minWidth: 140 }}
        startIcon={<Add />}
        onClick={onAddResource}
      >
        Add resource
      </Button>
    )}
  </Stack>
);

export default ManageActionsBar;
